enum MedicalItemViewMode {
    View = 1,
    Edit = 2
}

enum MedicalItemViewOrigin {
    Note = 1,
    Summary = 2,
    PatientLabResultTab = 3,
    ResultTab = 4,
    DocumentsTab = 5,
    PatientDocumentsTab = 6,
    PharmacyOrders = 7
}

enum MedicationsOrigin {
    Unknown = 0,
    MYLE = 1,
    DSQ = 2,
    Rx = 3
}

enum MedicationsStatus {
    Unknown = 0,
    Active = 1,
    Ceased = 2,
    Completed = 3,
    Expired = 4
}

export { MedicalItemViewMode, MedicalItemViewOrigin, MedicationsOrigin, MedicationsStatus };
